/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import { React } from 'react'
import AnimatedList from '../../../../components/Animation/AnimatedList'
import { convertEpochToDateFormat } from '../../../../CommonMethods/DateConversion'
import { useSelector } from 'react-redux'

const TableBodyProviderAlert = ({ tableData,
    indexNum }) => {


    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const date=convertEpochToDateFormat(tableData?.created_at,dateformat)

    return (
        <>
            <AnimatedList
                id={tableData.patient_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                removeHover={true}

                child={
                    <>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{date}</td>
                        <td className="px-[18px] py-2 text-sm text-start break-all font-normal text-[#031624]">{(tableData?.alert_message === "" || tableData?.alert_message===undefined) ? "-" : tableData?.alert_message }</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.status}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                            {(tableData?.acknowledged_first_name && tableData?.acknowledged_last_name) 
                                ? `${tableData?.acknowledged_first_name || ''} ${tableData?.acknowledged_last_name || ''}`
                                : "-"
                            }
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                            {tableData?.recipients && tableData.recipients.length > 0 ? (
                                tableData.recipients.map((item, index) => (
                                    <span key={item?.recepient_id}>
                                        <span>
                                            {item?.recepient_name}
                                        </span>
                                        {index < tableData.recipients.length - 1 && ', '}
                                    </span>
                                ))
                            ) : (
                                <span>-</span>
                            )}

                        </td>
                    </>

                } />

        </>
    )
}

export default TableBodyProviderAlert